// Servicio para gestión de notificaciones
import { http } from '../lib/api';

export const notificacionesAPI = {
  // Obtener notificaciones del usuario actual
  obtenerNotificaciones: async (params = {}) => {
    const queryParams = new URLSearchParams();
    
    if (params.skip) queryParams.append('skip', params.skip);
    if (params.limit) queryParams.append('limit', params.limit);
    if (params.solo_no_leidas) queryParams.append('solo_no_leidas', 'true');
    
    const url = `/notificaciones${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
    const response = await http.get(url);
    return response.data;
  },

  // Marcar una notificación como leída
  marcarComoLeida: async (notificacionId) => {
    const response = await http.post(`/notificaciones/${notificacionId}/marcar-leida`);
    return response.data;
  },

  // Eliminar una notificación
  eliminarNotificacion: async (notificacionId) => {
    const response = await http.delete(`/notificaciones/${notificacionId}`);
    return response.data;
  },

  // Marcar todas las notificaciones como leídas
  marcarTodasLeidas: async () => {
    const response = await http.post('/notificaciones/marcar-todas-leidas');
    return response.data;
  }
};

export default notificacionesAPI;